import React, { useState } from "react";
import '../Bathroom/BathroomCleaningInfo.css'; // Import a CSS file for full home cleaning styles
import ThumbImg from '../../Images/Serviceimg/thumbs-up.png';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'; // Import the expand icon
import RemoveImg from '../../Images/Serviceimg/remove.png';

const FullHomeCleaningInfo = () => {
    const [activeIndex, setActiveIndex] = useState(null); // State to manage the active question

    const handleToggle = (index) => {
        // Toggle the active index on click
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="cleaning-card">
            <div className="section-heading">Included</div>
            <ul className="service-list">
                <li className="service-item">
                    <div className="thumb-icon"><img src={ThumbImg} alt="" /></div>
                    Dusting - Removal of dust from all surfaces, including furniture, shelves, and decor items
                </li>
                <li className="service-item">
                    <div className="thumb-icon"><img src={ThumbImg} alt="" /></div>
                    Vacuuming - Thorough vacuuming of carpets, rugs, and upholstery
                </li>
                <li className="service-item">
                    <div className="thumb-icon"><img src={ThumbImg} alt="" /></div>
                    Mopping - Cleaning hard floors with appropriate solutions
                </li>
                <li className="service-item">
                    <div className="thumb-icon"><img src={ThumbImg} alt="" /></div>
                    Kitchen Cleaning - Detailed cleaning of countertops, appliances, and cabinets
                </li>
                <li className="service-item">
                    <div className="thumb-icon"><img src={ThumbImg} alt="" /></div>
                    Bathroom Cleaning - Comprehensive cleaning of sinks, toilets, tubs, and showers
                </li>
                <li className="service-item">
                    <div className="thumb-icon"><img src={ThumbImg} alt="" /></div>
                    Window Cleaning - Spotless cleaning of all accessible windows
                </li>
                <li className="service-item">
                    <div className="thumb-icon"><img src={ThumbImg} alt="" /></div>
                    Final Touch-Up - Ensuring all areas are tidy and in order before leaving
                </li>
            </ul>

            <div className="section-heading">Excluded</div>
            <ul className="service-list">
                <li className="service-item">
                    <div className="thumb-icon"><img src={RemoveImg} alt="" /></div>
                    Heavy Duty Cleaning of Attics/Basements
                </li>
                <li className="service-item">
                    <div className="thumb-icon"><img src={RemoveImg} alt="" /></div>
                    Cleaning of Outdoor Areas (Patios, Decks, Garages)
                </li>
                <li className="service-item">
                    <div className="thumb-icon"><img src={RemoveImg} alt="" /></div>
                    Removal of Hazardous Materials
                </li>
            </ul>

            <div className="section-heading">Frequently Asked Questions</div>

            {[
                { question: "Is this service applicable for all types of homes?", answer: "Yes, this service can be performed in all types of homes, including apartments, houses, and condos." },
                { question: "Will the cleaners move my furniture to clean underneath?", answer: "Our team will move lightweight furniture but will not move heavy or fragile items." },
                { question: "How long does the full home cleaning service take?", answer: "The duration depends on the size of the home but typically takes 3-5 hours." },
                { question: "Can I schedule a cleaning on short notice?", answer: "We recommend booking in advance, but we may accommodate last-minute requests based on availability." },
            ].map((faq, index) => (
                <div className="faq-accordion" key={index}>
                    <div className="faq-question">
                        <div>{faq.question}</div>
                        <ExpandMoreIcon className={`faq-arrow ${activeIndex === index ? "rotate" : ""}`} onClick={() => handleToggle(index)} />
                    </div>
                    {activeIndex === index && (
                        <div className="faq-answer">
                            <div>{faq.answer}</div>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default FullHomeCleaningInfo;
